/** Public identity only, never legal/booking identities or communications. */
export function publicNameParts(source) {
  const first_name = source?.first_name?.trim() || "";
  const surname = source?.last_name?.trim() || "";
  // Even an exact surname suffix can be part of a legitimate compound given
  // name. Ambiguous imports need authoritative review, not word splitting.
  // Code point plus combining marks, not a UTF-16 half-character.
  const last_name = surname.normalize("NFC").match(/^\P{M}\p{M}*/u)?.[0] || "";
  return { first_name, last_name };
}

export function publicDisplayName(source) {
  const { first_name, last_name } = publicNameParts(source);
  return [first_name, last_name ? `${last_name}.` : ""].filter(Boolean).join(" ");
}
